import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
/* CDK imports */
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTreeModule } from '@angular/cdk/tree';
import {
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
  LocationStrategy,
  PathLocationStrategy
} from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientJsonpModule,
  HttpClientModule
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
/* Material imports*/
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import {
  MatPaginatorIntl,
  MatPaginatorModule
} from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  BciCoreModule,
  BciLayoutModule,
  BciSharedModule,
  BreadcrumbsService
} from '@bci-web-core/core';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
/* angular-highcharts */
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import {
  OAuthModule,
  OAuthService,
  UrlHelperService
} from 'angular-oauth2-oidc';
import { AngularSplitModule } from 'angular-split';
import more from 'highcharts/highcharts-more.src';
import draggable from 'highcharts/modules/draggable-points.src';
import exporting from 'highcharts/modules/exporting.src';
import solidGauge from 'highcharts/modules/solid-gauge.src';
import stock from 'highcharts/modules/stock.src';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
//
/* Organization Chart Module */
import { OrganizationChartModule } from 'src/app/orgChart/components/organizationchart/organizationchart';
import { TreeChartModule } from 'src/app/orgChart/components/treechart/treechart';
// Directive && PIPE
import {
  FrequenciesPipe,
  NumberOnlyDirective,
  OperatorsPipe,
  PositiveDecimalNumberDirective
} from 'src/app/shared/index';
/* platform-browser */
import { environment } from '../environments/environment';
/* App components */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppGuard } from './app.guard';
import { AddDcuComponent } from './Components/add/add-dcu/add-dcu.component';
import { AddLoadComponent } from './Components/add/add-load/add-load.component';
import { AddMeterComponent } from './Components/add/add-meter/add-meter.component';
import { AddNodeComponent } from './Components/add/add-node/add-node.component';
import { NodeDetailComponent } from './Components/add/add-node/node-detail/node-detail.component';
import { AddUserSuccessModalComponent } from './Components/add/add-user/add-user-success-modal/add-user-success-modal.component';
import { AddUserComponent } from './Components/add/add-user/add-user.component';
import { HelpComponent } from './Components/help/help.component';
import { HomeComponent } from './Components/home/home.component';
import { LangChangeComponent } from './Components/lang-change/lang-change.component';
import { EqBenchmarkingComponent } from './Components/report/eq-benchmarking/eq-benchmarking.component';
import { ManageReportComponent } from './Components/report/manage-report/manage-report.component';
import { ManageSolarSchedulerComponent } from './Components/report/manage-solar-scheduler/manage-solar-scheduler.component';
import { SolarDailyReportComponent } from './Components/report/solar-daily-report/solar-daily-report.component';
import { SolarMonthlyReportComponent } from './Components/report/solar-monthly-report/solar-monthly-report.component';
import { RoleManagementComponent } from './Components/role-management/role-management.component';
// Energy
import {
  DataTagComponent,
  DeepDiveComponent,
  EnergyComponent,
  EnergyDashboardComponent,
  EnergyTrendsComponent,
  LoadOnTreeComponent,
  MeterViewComponent,
  NotificationsComponent as NotificationsOnEnergyComponent,
  RealTimeComponent,
  SpecificEnergyComponent,
  TestbenchOverviewComponent,
  TransformerDashboardComponent,
  TransformerMonitoringComponent
} from './Components/site/energy-dashboard/index';
// Kpi Benchmarking
import { KpiBenchmarkingComponent } from './Components/site/kpi-benchmarking/kpi-benchmarking.component';
// Machine Monitoring
import { MachineMonitoringComponent } from './Components/site/machine-monitoring/machine-monitoring.component';
// Over View
import { OverViewComponent } from './Components/site/over-view/over-view.component';
import { PlantNavigationComponent } from './Components/site/over-view/plant-navigation/plant-navigation.component';
import { SensorTrendModalComponent } from './Components/site/over-view/sensor-trend-modal/sensor-trend-modal.component';
import { PlantPerformanceComponent } from './Components/site/plant-performance/plant-performance.component';
import { ProjectInfoComponent } from './Components/site/project-info/project-info.component';
// Site
import { SiteDashboardComponent } from './Components/site/site-dashboard.component';
import { SiteInfoComponent } from './Components/site/site-info/site-info.component';
import { AlertsConfigurationComponent } from './Components/site/site-master/alerts-configuration/alerts-configuration.component';
// eslint-disable-next-line max-len
import { AddNodeDetailModalComponent } from './Components/site/site-master/click-and-navigation-details/add-node-detail-modal/add-node-detail-modal.component';
import { AddNodeInfoModalComponent } from './Components/site/site-master/click-and-navigation-details/add-node-info-modal/add-node-info-modal.component';
// eslint-disable-next-line max-len
import { ClickAndNavigationDetailsComponent } from './Components/site/site-master/click-and-navigation-details/click-and-navigation-details.component';
// eslint-disable-next-line max-len
import { UploadImageConfigurationComponent } from './Components/site/site-master/click-and-navigation-details/upload-image-configuration/upload-image-configuration.component';
// eslint-disable-next-line max-len
import { UploadImageModalComponent } from './Components/site/site-master/click-and-navigation-details/upload-image-modal/upload-image-modal.component';
import { ConnectionDetailsComponent } from './Components/site/site-master/connection-details/connection-details.component';
// eslint-disable-next-line max-len
import { AssignMeterModalComponent } from './Components/site/site-master/data-acquisition-layout/assign-meter-modal/assign-meter-modal.component';
import { DataAcquisitionLayoutComponent } from './Components/site/site-master/data-acquisition-layout/data-acquisition-layout.component';
import { LoadMasterComponent } from './Components/site/site-master/load-master/load-master.component';
import { MdListComponent } from './Components/site/site-master/md-list/md-list.component';
import { ProcessAndLoadDetailsComponent } from './Components/site/site-master/process-and-load-details/process-and-load-details.component';
import { ReportConfigurationComponent } from './Components/site/site-master/report-configuration/report-configuration.component';
import { ReportGroupComponent } from './Components/site/site-master/report-group/report-group.component';
import { ReservesAndSourcesComponent } from './Components/site/site-master/reserves-and-sources/reserves-and-sources.component';
import { SetupProjectComponent } from './Components/site/site-master/setup-project/setup-project.component';
import { ShiftDetailsComponent } from './Components/site/site-master/shift-details/shift-details.component';
import { SiteCreationComponent } from './Components/site/site-master/site-creation/site-creation.component';
import { SiteDetailComponent } from './Components/site/site-master/site-detail/site-detail.component';
import { SiteMasterComponent } from './Components/site/site-master/site-master.component';
import { AddNodeTreeConfigurationModalComponent } from './Components/site/site-master/tree-configuration/add-node-tree-configuration-modal/add-node-tree-configuration-modal.component';
import { GenericTreeViewConfigurationComponent } from './Components/site/site-master/tree-configuration/generic-tree-view-configuration/generic-tree-view-configuration.component';
import { InverterViewConfigurationComponent } from './Components/site/site-master/tree-configuration/inverter-view-configuration/inverter-view-configuration.component';
import { LoadOnViewConfigurationComponent } from './Components/site/site-master/tree-configuration/load-on-view-configuration/load-on-view-configuration.component';
import { TreeConfigurationComponent } from './Components/site/site-master/tree-configuration/tree-configuration.component';
import { WidgetConfigurationComponent } from './Components/site/site-master/widget-configuration/widget-configuration.component';
import { ArchitectureComponent } from './Components/site/solar-dashboard/architecture/architecture.component';
import { InverterViewComponent } from './Components/site/solar-dashboard/inverter-view/inverter-view.component';
import { NotificationsComponent } from './Components/site/solar-dashboard/notifications/notifications.component';
// eslint-disable-next-line max-len
import { PerformanceCharacteristicComponent } from './Components/site/solar-dashboard/plant-overview/performance-characteristic/performance-characteristic.component';
import { PlantKeyComponent } from './Components/site/solar-dashboard/plant-overview/plant-key/plant-key.component';
import { PlantOverviewComponent } from './Components/site/solar-dashboard/plant-overview/plant-overview.component';
import { PlantStatusComponent } from './Components/site/solar-dashboard/plant-overview/plant-status/plant-status.component';
import { PowerIrradianceComponent } from './Components/site/solar-dashboard/plant-overview/power-irradiance/power-irradiance.component';
import { SolarEnergyComponent } from './Components/site/solar-dashboard/plant-overview/solar-energy/solar-energy.component';
// eslint-disable-next-line max-len
import { SolarLongTermTrendComponent } from './Components/site/solar-dashboard/plant-overview/solar-long-term-trend/solar-long-term-trend.component';
import { SolarYieldComponent } from './Components/site/solar-dashboard/plant-overview/solar-yield/solar-yield.component';
// Solar Dashboard
import { SolarDashboardComponent } from './Components/site/solar-dashboard/solar-dashboard.component';
// Utilites
import { UtilitiesComponent } from './Components/site/utilities/utilities.component';
import { AddEditUserModalComponent } from './Components/user/add-edit-user-modal/add-edit-user-modal.component';
import { ContactUsModalComponent } from './Components/user/contact-us-modal/contact-us-modal.component';
import { FeatureSelectionModalComponent } from './Components/user/feature-selection-modal/feature-selection-modal.component';
import { LoginComponent } from './Components/user/login.component';
import { SsoLoginModalComponent } from './Components/user/sso-login-modal/sso-login-modal.component';
import { SystemPrivacyModalComponent } from './Components/user/system-privacy-modal/system-privacy-modal.component';
import { UserManagementComponent } from './Components/user/user-management/user-management.component';
import { DcuInventoryComponent } from './Components/view/dcu-inventory/dcu-inventory.component';
import { LoadInventoryComponent } from './Components/view/load-inventory/load-inventory.component';
import { MeterInventoryComponent } from './Components/view/meter-inventory/meter-inventory.component';
import { AppConfigService } from './services/app-config.service';
import { CommonService } from './services/common.service';
/* App Service */
import { DataService } from './services/data.service';
import { EnergyService, PlantServiceService } from './services/index';
import { NotificationService } from './services/notification-service.service';
import {
  ConfirmationDialog,
  ControlListComponent,
  DateService,
  FabricService,
  WarningDialog
} from './shared/index';
import { ErrorInterceptor, JwtInterceptor } from './shared/interceptor';
// Pipes
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AddBuildingComponent } from './Components/add/add-building/add-building.component';
import { PeakDemandReportComponent } from './Components/export/peak-demand-report/peak-demand-report.component';
import { RealtimeDataComponent } from './Components/export/realtime-data/realtime-data.component';
import { AirReportComponent } from './Components/report/air-report/air-report.component';
import { EnergyTreeExcelComponent } from './Components/report/energy-tree-excel/energy-tree-excel.component';
import { GasReportComponent } from './Components/report/gas-report/gas-report.component';
import { WaterReportComponent } from './Components/report/water-report/water-report.component';
import { UtilityConsumptionChartsComponent } from './Components/site/over-view/utility-consumptionCharts/utility-consumptionCharts.component';
import { PostLoginComponent } from './Components/user/post-login/post-login.component';
import { MeterIdFilterPipe } from './shared/pipes/filters';
import { SelectRoleFilterPipe } from './shared/pipes/rolefilter.pipe';
import { MatPaginationIntlService } from './shared/services/mat-pagination-intl.service';
import { UserService } from './shared/user-service.service';

export function highchartsModules() {
  // apply Highcharts Modules to this array
  return [stock, more, exporting, draggable, solidGauge];
  // return [stock];
}

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmationDialog,
    ControlListComponent,
    MdListComponent,
    HomeComponent,
    SolarDashboardComponent,
    PlantOverviewComponent,
    InverterViewComponent,
    ArchitectureComponent,
    NotificationsComponent,
    PlantStatusComponent,
    PowerIrradianceComponent,
    PerformanceCharacteristicComponent,
    SolarEnergyComponent,
    SolarYieldComponent,
    SolarLongTermTrendComponent,
    ProjectInfoComponent,
    SiteInfoComponent,
    PlantPerformanceComponent,
    PlantKeyComponent,
    SolarDailyReportComponent,
    SolarMonthlyReportComponent,
    EnergyDashboardComponent,
    TestbenchOverviewComponent,
    RealTimeComponent,
    DeepDiveComponent,
    MeterViewComponent,
    EnergyComponent,
    EnergyTrendsComponent,
    WarningDialog,
    DataTagComponent,
    SiteDashboardComponent,
    OverViewComponent,
    UtilitiesComponent,
    MachineMonitoringComponent,
    KpiBenchmarkingComponent,
    LoadOnTreeComponent,
    SpecificEnergyComponent,
    TransformerMonitoringComponent,
    TransformerDashboardComponent,
    NotificationsOnEnergyComponent,
    SiteMasterComponent,
    SiteDetailComponent,
    SiteCreationComponent,
    ConnectionDetailsComponent,
    ShiftDetailsComponent,
    SetupProjectComponent,
    // Directive
    NumberOnlyDirective,
    PositiveDecimalNumberDirective,
    OperatorsPipe,
    FrequenciesPipe,
    //
    ProcessAndLoadDetailsComponent,
    ReportGroupComponent,
    LoadMasterComponent,
    ReservesAndSourcesComponent,
    AlertsConfigurationComponent,
    ReservesAndSourcesComponent,
    WidgetConfigurationComponent,
    ReportConfigurationComponent,
    DataAcquisitionLayoutComponent,
    AssignMeterModalComponent,
    // Pipes
    MeterIdFilterPipe,
    SelectRoleFilterPipe,
    ClickAndNavigationDetailsComponent,
    TreeConfigurationComponent,
    UploadImageConfigurationComponent,
    UploadImageModalComponent,
    AddNodeDetailModalComponent,
    AddNodeComponent,
    AddDcuComponent,
    AddMeterComponent,
    NodeDetailComponent,
    PlantNavigationComponent,
    AddUserComponent,
    AddUserSuccessModalComponent,
    LoadOnViewConfigurationComponent,
    InverterViewConfigurationComponent,
    AddNodeTreeConfigurationModalComponent,
    AddNodeInfoModalComponent,
    RoleManagementComponent,
    GenericTreeViewConfigurationComponent,
    UserManagementComponent,
    AddEditUserModalComponent,
    SsoLoginModalComponent,
    FeatureSelectionModalComponent,
    SystemPrivacyModalComponent,
    SensorTrendModalComponent,
    AddLoadComponent,
    MeterInventoryComponent,
    LoadInventoryComponent,
    DcuInventoryComponent,
    ManageReportComponent,
    ManageSolarSchedulerComponent,
    HelpComponent,
    EqBenchmarkingComponent,
    ContactUsModalComponent,
    LangChangeComponent,
    PostLoginComponent,
    RealtimeDataComponent,
    EnergyTreeExcelComponent,
    UtilityConsumptionChartsComponent,
    PeakDemandReportComponent,
    AddBuildingComponent,
    WaterReportComponent,
    AirReportComponent,
    GasReportComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    AppRoutingModule,
    BciCoreModule.forRoot({
      prod_environment: environment.production,
      core_config_url: '/assets/config/config.json?v1.1'
    }),
    BciLayoutModule,
    BciSharedModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTableModule,
    MatTabsModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatCardModule,
    MatListModule,
    MatExpansionModule,
    MatSidenavModule,
    MatPaginatorModule,
    MatGridListModule,
    MatTreeModule,
    MatSortModule,
    MatMenuModule,
    MatStepperModule,
    MatSnackBarModule,
    CdkStepperModule,
    /* CDK */
    OverlayModule,
    PortalModule,
    ChartModule,
    OrganizationChartModule,
    TreeChartModule,
    NgxDaterangepickerMd.forRoot(),
    NgxMatSelectSearchModule,
    CdkTreeModule,
    DragDropModule,
    AngularSplitModule.forRoot(),
    OAuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
    DataService,
    UserService,
    BreadcrumbsService,
    PlantServiceService,
    EnergyService,
    CommonService,
    NotificationService,
    DateService,
    FabricService,
    UrlHelperService,
    OAuthService,
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    AppGuard,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
    TranslateService,
    { provide: MatPaginatorIntl, useClass: MatPaginationIntlService }
    // { provide: HTTP_INTERCEPTORS, useClass: AdalInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
